import Flickity from 'flickity-fade';

class lightboxGallery extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const carousel = this.querySelector('[class*=-items]')
        const flickity = new Flickity(carousel, {
            imagesLoaded: true,
            cellAlign: 'center',
            contain: false,
            pageDots: false,
            fade: true
        })

        let scrollTop = 0;
        const documentRoot = document.documentElement;
        const closeButton = this.querySelector('.lightboxGallery-close');
        closeButton.addEventListener('click', () => {
            documentRoot.setAttribute('data-lightbox', 'close')
            document.body.style.top = null;
            documentRoot.scrollTop = scrollTop;
        })

        this.addEventListener('open-lightbox', (e) => {
            scrollTop = documentRoot.scrollTop;
            document.body.style.top = `-${scrollTop}px`;
            documentRoot.setAttribute('data-lightbox', 'open')
            flickity.select(e.detail.index)
        })
    }
}

customElements.define("cstm-lightbox-gallery", lightboxGallery);